export const STATUS_ORDER = ['PASSED', 'FAILED', 'RUNNING', 'ERROR']

export function statusTone(status) {
  const s = String(status || '').toUpperCase()
  if (s === 'PASSED') return 'success'
  if (s === 'FAILED') return 'warning'
  if (s === 'RUNNING') return 'info'
  if (s === 'ERROR') return 'danger'
  return 'neutral'
}

export function asList(payload) {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

export function formatLocalDate(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString()
}

export function isPositiveInt(value) {
  const num = Number(value)
  return Number.isInteger(num) && num > 0
}

export function isIntInRange(value, min, max) {
  const num = Number(value)
  return Number.isInteger(num) && num >= min && num <= max
}

export function parseOptionalInt(value) {
  if (value == null || value === '') return undefined
  const n = Number(value)
  if (!Number.isInteger(n)) return null
  return n
}

export function hasRunning(items) {
  return asList(items).some((item) => String(item?.status || '').toUpperCase() === 'RUNNING')
}

export function extractTaskId(payload) {
  return payload?.task_id || payload?.celery_task_id || payload?.id || null
}
